import { render } from "./chartD.vue?vue&type=template&id=636d81a8&scoped=true"
import script from "./chartD.vue?vue&type=script&lang=ts"
export * from "./chartD.vue?vue&type=script&lang=ts"

import "./chartD.vue?vue&type=style&index=0&id=636d81a8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-636d81a8"

export default script